import { Title } from "./SignupStyles";

function OttSent() {

  return (
    <div className="600:w-[360px] mx-auto mt-12 flex flex-col pb-12 px-4">
      <Title>OTTSent</Title>
    </div>
  );
}

export default OttSent;
